module.exports = __webpack_public_path__ + "static/media/taggis-qr-hero-image.fd21d596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taggis-qr-hero-image.png
// module id = 374
// module chunks = 3